import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { _throw } from 'rxjs/observable/throw';
import { ReportLayoutDto } from '../../../../vas/business-objects/report-layout/report-layout.dto';
import { VasAppFacade } from '../../../../vas/services/vas-app-facade.service';
import { VASRestService } from '../../api/vas-rest';
import { IOperation } from '../operation.interface';
import { ReportLayoutChangeQItem } from '../report-layout-item';
import { Operation } from './operation';

export class ReportLayoutOperation extends Operation implements IOperation {

    transactionType = 'ReportLayoutOperation';

    constructor(public item: ReportLayoutChangeQItem, protected restService: VASRestService, protected appFacade: VasAppFacade) {
        super(item, restService, appFacade);
    }

    post(item: ReportLayoutChangeQItem = this.item): Observable<Response> {
        return this.appFacade.objects.reportLayout.api.create(item.account, item.data as ReportLayoutDto)
            .catch(error => {
                // if the item was already posted we should ignore the error
                if (error.status === 409) {
                    return of(undefined);
                }

                return _throw(error);
            })
            .concatMap(() => this.appFacade.objects.reportLayout.api.sendContent(item.account, item.id, item.data as ReportLayoutDto));
    }

    patch(item: ReportLayoutChangeQItem = this.item): Observable<Response> {
        return this.appFacade.objects.reportLayout.api.update(item.account, item.id, item.data as ReportLayoutDto)
            .concatMap(() => this.appFacade.objects.reportLayout.api.sendContent(item.account, item.id, item.data as ReportLayoutDto));
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/operations/report-layout-operation.ts